import { ProcessExecutionRequest } from "@nens/rana/api-v1";
import { getRanaApiV1 } from "@nens/rana/api-v1";
import { UseMutationWithErrorHandlerOptions, useMutationWithErrorHandler } from "@nens/ranalib";

import { useInvalidateJobListQuery } from "@/queries/query-job";

const startProcess = async (request: Omit<ProcessExecutionRequest, "tenantId">) => {
  return await getRanaApiV1().ProcessesApi.processExecution(request);
};

export const useStartProcess = (
  mutationOptions?: UseMutationWithErrorHandlerOptions<
    { jobId: string },
    unknown,
    Omit<ProcessExecutionRequest, "tenantId">
  >
) => {
  const invalidateJobsQuery = useInvalidateJobListQuery();
  return useMutationWithErrorHandler(
    async (props: Omit<ProcessExecutionRequest, "tenantId">): Promise<{ jobId: string }> => {
      const response = await startProcess(props);

      invalidateJobsQuery();

      return response;
    },
    mutationOptions
  );
};
